// Native bridge — talks to the Swift WKScriptMessageHandlerWithReply registered
// under the name "hearth". Each postMessage returns a Promise directly
// (WKScriptMessageHandlerWithReply's built-in reply mechanism), so we don't
// need correlation IDs on this side.

import type { Bridge } from './index'
import type { BridgeMethods } from './types'
import { createEmitter } from './emitter'

type WebKitHandler = {
  postMessage(body: unknown): Promise<unknown>
}

export function createNativeBridge(): Bridge {
  const handler = (
    window as unknown as {
      webkit: { messageHandlers: { hearth: WebKitHandler } }
    }
  ).webkit.messageHandlers.hearth

  const emitter = createEmitter()

  return {
    isNative: true,
    isAndroid: false,
    async call<K extends keyof BridgeMethods>(
      method: K,
      args?: BridgeMethods[K]['args'],
    ): Promise<BridgeMethods[K]['result']> {
      const result = await handler.postMessage({ method, args: args ?? {} })
      return result as BridgeMethods[K]['result']
    },
    on: emitter.on,
    emit: emitter.emit,
  }
}
